export const languages = [
  { code: "en", label: "English" },
  { code: "zh", label: "中文" },
  { code: "es", label: "Español" },
  { code: "ru", label: "Русский" },
  { code: "tg", label: "Тоҷикӣ" }
] as const;

export type Lang = (typeof languages)[number]["code"];
export const defaultLang: Lang = "en";

const dict: Record<Lang, Record<string, string>> = {
  en: { shop: "Shop", cart: "Cart", checkout: "Checkout", account: "Account", search: "Search products", buy: "Buy now", add: "Add to cart", pay: "Payment instructions", admin: "Admin" },
  zh: { shop: "商城", cart: "购物车", checkout: "结算", account: "账户", search: "搜索商品", buy: "立即购买", add: "加入购物车", pay: "付款说明", admin: "后台" },
  es: { shop: "Tienda", cart: "Carrito", checkout: "Pagar", account: "Cuenta", search: "Buscar productos", buy: "Comprar", add: "Añadir", pay: "Instrucciones de pago", admin: "Admin" },
  ru: { shop: "Магазин", cart: "Корзина", checkout: "Оплата", account: "Аккаунт", search: "Поиск товаров", buy: "Купить", add: "В корзину", pay: "Инструкция оплаты", admin: "Админ" },
  tg: { shop: "Мағоза", cart: "Сабад", checkout: "Пардохт", account: "Ҳисоб", search: "Ҷустуҷӯ", buy: "Харидан", add: "Ба сабад", pay: "Дастури пардохт", admin: "Админ" }
};

export function normalizeLang(value?: string): Lang {
  return languages.some((lang) => lang.code === value) ? (value as Lang) : defaultLang;
}

export function t(lang: string | undefined, key: string) {
  const code = normalizeLang(lang);
  return dict[code][key] ?? dict.en[key] ?? key;
}

export function switchLangPath(pathname: string, nextLang: Lang) {
  const parts = pathname.split("/").filter(Boolean);
  if (languages.some((lang) => lang.code === parts[0])) parts[0] = nextLang;
  else parts.unshift(nextLang);
  return `/${parts.join("/")}`;
}
